export default {
  "nav.spreadsheet": "Hoja de cálculo USFans",
  "nav.reviews": "Reseñas",
  "nav.shipping": "Envío",
  "nav.guides": "Guías",
  "nav.safety": "Seguridad",
  "nav.faq": "Preguntas frecuentes",
  "nav.cta": "Explorar hoja de cálculo",
  "nav.home": "Inicio",
  "nav.shoppingGuide": "Guía de compras",

  "hero.eyebrow": "EL CENTRO DE RECURSOS USFANS",
  "hero.h1": "Hoja de cálculo USFans: encuentra, compara y explora recursos USFans",
  "hero.subtitle": "¿Buscas una forma más clara de explorar hojas de cálculo USFans, información de productos, recursos de vendedores, guías de control de calidad e información de envío? USFansLink reúne recursos útiles de USFans en un centro organizado y fácil de buscar.",
  "hero.ctaPrimary": "Explorar hoja de cálculo USFans",
  "hero.ctaSecondary": "Leer la guía de USFans",
  "hero.trust": "Recurso independiente • Actualizado con regularidad • Creado para facilitar la investigación",
  "hero.cardBadge": "Hoja de cálculo USFans",
  "hero.cardTitle": "Centro de recursos organizado",
  "hero.cardText": "Explora categorías, compara guías y salta directamente a los productos que necesitas.",

  "buttons.usfans": "hoja de cálculo usfans",
  "buttons.buyNow": "Cómpralo ahora",

  "categories.title": "Explora por categoría",
  "categories.subtitle": "Elige una categoría y salta directamente a los productos que necesitas en nuestra web principal.",
  "categories.placeholder": "Selecciona una categoría",
  "categories.go": "Ir a la categoría",

  "cat.shoes": "Zapatos",
  "cat.hoodies": "Sudaderas / Jerséis",
  "cat.tshirts": "Camisetas",
  "cat.jackets": "Chaquetas",
  "cat.pants": "Pantalones / Pantalones cortos",
  "cat.headwear": "Gorros y sombreros",
  "cat.sets": "Conjuntos",
  "cat.underwear": "Ropa interior / Calzoncillos",
  "cat.jersey": "Camiseta deportiva",
  "cat.accessories": "Accesorios",
  "cat.bags": "Bolsos",
  "cat.belts": "Cinturones",
  "cat.perfumes": "Perfumes",
  "cat.other": "Otras cosas",

  "value.title": "Todo lo que necesitas para investigar USFans en un solo lugar",
  "value.subtitle": "Recursos organizados y prácticos que te ayudan a evaluar la información antes de decidir.",
  "value.card1.title": "Hoja de cálculo USFans",
  "value.card1.text": "Explora recursos organizados de hojas de cálculo y aprende a evaluar la información antes de tomar decisiones.",
  "value.card2.title": "Reseñas de USFans",
  "value.card2.text": "Comprende los factores clave que debes comprobar al investigar USFans y servicios relacionados.",
  "value.card3.title": "Información de envío",
  "value.card3.text": "Descubre cómo pueden variar los costes, los métodos, las opciones de entrega y las posibles tarifas.",
  "value.card4.title": "Recursos de control de calidad",
  "value.card4.text": "Comprende las fotos de control de calidad, los detalles del producto y lo que los compradores deberían verificar.",
  "value.card5.title": "Centro de seguridad",
  "value.card5.text": "Aprende a reconocer enlaces sospechosos, proteger tus cuentas y evaluar sitios web externos.",

  "featured.title": "Explora la hoja de cálculo USFans",
  "featured.text": "Usa nuestro recurso de hoja de cálculo USFans como punto de partida para investigar. Compara información, explora guías relacionadas y descubre recursos prácticos sin saltar entre páginas dispersas.",
  "featured.cta": "Ver hoja de cálculo USFans",

  "review.title": "Reseña de USFans: ¿qué deberías comprobar?",
  "review.text": "Antes de usar cualquier servicio de compras o abastecimiento en línea, es importante investigar la reputación, la información disponible, las opciones de envío, los procesos de almacén, las prácticas de pago y la seguridad de la cuenta. Nuestras guías explican qué buscar para que decidas con más información.",
  "review.cta": "Leer la guía de reseñas de USFans",

  "shipping.title": "Guía de costes de envío de USFans",
  "shipping.text": "Los costes de envío pueden variar según el destino, el tamaño del paquete, el peso, el método de envío y otros factores. Aprende a comparar opciones de envío y a entender la información mostrada antes de realizar un pedido.",
  "shipping.cta": "Explorar la guía de envío",

  "safety.title": "¿Es USFans legítimo? Aprende qué comprobar",
  "safety.text": "¿Buscas «USFans legit»? No te fíes de una sola reseña o publicación social. Aprende a evaluar las URLs, las páginas de pago, la seguridad de la cuenta, la información del vendedor, los enlaces externos y otras señales de confianza.",
  "safety.cta": "Leer la guía de seguridad de USFans",

  "article.title": "Última guía de USFans",
  "article.text": "Nuestra guía original y detallada de la hoja de cálculo USFans cubre qué es, cómo usarla, qué comprobar antes de comprar y los puntos clave de seguridad a tener en cuenta.",
  "article.cta": "Leer la guía completa",

  "final.title": "¿Listo para explorar los recursos de USFans?",
  "final.text": "Empieza por la hoja de cálculo USFans, explora las últimas guías y usa la información que mejor se adapte a tus necesidades.",
  "final.ctaPrimary": "Explorar hoja de cálculo USFans",
  "final.ctaSecondary": "Visitar la web principal",

  "pillars.eyebrow": "Guías de USFans",
  "pillars.title": "Guías principales de USFans",
  "pillars.subtitle": "Guías originales y detalladas sobre la hoja de cálculo USFans, el envío, la seguridad, el control de calidad, los cupones y más.",
  "pillars.readMore": "Leer más",

  "footer.tagline": "Un centro de recursos independiente que reúne recursos útiles de USFans en un solo lugar organizado.",
  "footer.disclosure": "Recurso informativo de gestión independiente. No afiliado oficialmente a USFans.",
  "footer.explore": "Explorar",
  "footer.resources": "Recursos",
  "footer.navHome": "Inicio",
  "footer.navGuide": "Guía de la hoja de cálculo USFans",
  "footer.navCategories": "Categorías",
  "footer.rights": "Todos los derechos reservados."
};